import React, { useState, useEffect } from "react";
import {
  Avatar,
  Popover,
  Modal,
  Select,
  Typography,
  Space,
  notification,
} from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { UserOutlined } from "@ant-design/icons";
import DefaultModuleUpdateForm from "../../routes/Forms/DefaultModuleUpdateForm";
import { useTranslation } from "react-i18next";
const { Option } = Select;
const { Title, Text } = Typography;
const userName = localStorage.getItem("userName");

const UserInfo = () => {
  const [defaultModuleModalVisible, setDefaultModuleModalVisible] =
    useState(false);
  const [accessSupportPanel, setAccessSupportPanel] = useState();
  const [languageModalVisible, setLanguageModalVisible] = useState(false);
  const [useTranslateOnScreen, setUseTranslateOnScreen] = useState(false);
  const { i18n, t } = useTranslation();
  useEffect(() => {
    RequestHandler.get("/SupportPanel/AccessControl").then((response) => {
      setAccessSupportPanel(response);
    });

    RequestHandler.get("/TenantParameter/UseTranslateOnScreen").then(
      (response) => {
        if (response?.success) {
          setUseTranslateOnScreen(response?.data);
        }
      }
    );

    const savedLang = localStorage.getItem("language");
    if (savedLang && i18n.language !== savedLang) {
      i18n.changeLanguage(savedLang);
    } else {
      i18n.changeLanguage("tr");
    }
  }, []);

  const userSignOut = () => {
    RequestHandler.get("/Auth/Logout").then((response) => {
      if (response.success) {
        RequestHandler.removeUserInfo();
        window.location.reload();
      }
    });
  };

  const changeLanguage = (e) => {
    i18n.changeLanguage(e).then(() => {
      const lang = i18n.language;
      localStorage.setItem("language", lang);
      let message = "";

      switch (lang) {
        case "tr":
          message = "İşlem Başarılı.";
          break;
        case "en":
          message = "Operation Successful.";
          break;
        default:
          message = "İşlem Başarılı.";
      }

      notification.success({
        message,
        duration: 3,
      });
    });
  };

  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li>{userName}</li>
      <hr></hr>
      <li onClick={() => setDefaultModuleModalVisible(true)}>
        {t("changeHomepage")}
      </li>
      <li>
        <a style={{ color: "#545454" }} href="/account-transaction-role">
          {t("parameters")}
        </a>
      </li>

      <li>
        <a style={{ color: "#545454" }} href="/password-change">
          {t("changePassword")}
        </a>
      </li>
      {accessSupportPanel ? (
        <>
          <li>
            <a style={{ color: "#545454" }} href="/support-panel/2">
              {t("mySupportRequests")}
            </a>
          </li>

          <a style={{ color: "#545454" }} href="/support-panel/1">
            <li>{t("faq")}</li>
          </a>
        </>
      ) : null}
      {useTranslateOnScreen ? (
        <li onClick={() => setLanguageModalVisible(true)}>
          {t("languageSelection")}
        </li>
      ) : null}
      <li onClick={() => userSignOut()}>{t("signOut")}</li>
    </ul>
  );

  const supportPanelDropdown = (
    <ul className="gx-user-popover">
      <li>
        <a
          style={{ color: "#545454", whiteSpace: "nowrap" }}
          href="/support-panel/1"
        >
          Sıkça Sorulan Sorular
        </a>
      </li>
      <li>
        <a style={{ color: "#545454" }} href="/support-panel/2">
          Destek Talebi
        </a>
      </li>
    </ul>
  );

  return (
    <>
      <Popover
        overlayClassName="gx-popover-horizantal"
        placement="bottomRight"
        content={userMenuOptions}
        trigger="click"
      >
        <Avatar
          className="gx-avatar-name"
          style={{ backgroundColor: "white" }}
          icon={<UserOutlined style={{ color: "#086880" }} />}
        />
      </Popover>

      {/* <Popover
        overlayClassName="gx-popover-horizantal"
        placement="bottomRight"
        content={supportPanelDropdown}
        trigger="click"
      >
       <Avatar 
       className="gx-avatar-name" 
       style={{backgroundColor:'white',marginLeft:10}} 
       icon={<AliwangwangOutlined style={{color:'#086880'}}/>} />
      </Popover> */}

      <Modal
        id="defaultModuleModal"
        centered
        visible={defaultModuleModalVisible}
        onOk={() => setDefaultModuleModalVisible(false)}
        onCancel={() => setDefaultModuleModalVisible(false)}
        footer={null}
      >
        <DefaultModuleUpdateForm
          onSuccess={() => setDefaultModuleModalVisible(false)}
        />
      </Modal>

      <Modal
        id="languageModal"
        centered
        visible={languageModalVisible}
        onCancel={() => setLanguageModalVisible(false)}
        footer={null}
        closable={false}
        width={400}
        style={{ borderRadius: 12 }}
      >
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Space align="center">
            <GlobalOutlined style={{ fontSize: 24, color: "#1677ff" }} />
            <Title level={4} style={{ margin: 0 }}>
              {t("languageSelection")}
            </Title>
          </Space>

          <Text type="secondary">
            {t("languageSelectDescription")}
          </Text>

          <Select
            id="languageSelect"
            onChange={changeLanguage}
            placeholder=""
            size="large"
            style={{ width: "100%" }}
            value={i18n.language}
          >
            <Option value="tr">Türkçe</Option>
            <Option value="en">English</Option>
          </Select>
        </Space>
      </Modal>
    </>
  );
};

export default UserInfo;
